import React, { useState, useEffect } from 'react';
import MainTable from '../../../components/Table/PaginationTable.js';
import { useNavigate } from 'react-router-dom';
import { columnDefDefaultFn } from '../columns/columnDef.js';
import { useSelector, useDispatch } from 'react-redux';
import { fetchOrders, resetOrderState } from '../../../redux/orderSlice.js';
import FilterPanel from '../../../components/common components/FilterPanel.js';
import DownloadButton from '../../../components/common components/DownloadButton.js';
import FileOutlineIcon from '@mui/icons-material/Description';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem ,Button} from '@mui/material';
import LoaderComp from '../../../components/common components/Loader.js';

// import dataJSON from "../columns/dummyData.json";
// import { Troubleshoot } from '@mui/icons-material';


const OrdersInboxComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const { data, loading, error } = useState(''); // Assuming the state shape
  const tableData = useSelector((state) =>state.order.orderData);
    // console.log("**ORDER**", state.order.orderData)
  const isLoading = useSelector(state => state.order.loading.fetchOrders);
  const isError = useSelector(state => state.order.error);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [filterCriteria, setFilterCriteria] = useState({
    search: '',
    fromDate: '',
    toDate: ''
  });
  const isFetchOrdersLoading  = useSelector(state => Object.values(state.order.loading).some(status => status));
  // const { data, loading, error } = useSelector((state) => state.tableData); // Assuming the state shape
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const totalRecords = useSelector(state => state.order.paginationInfo?.totalRecords) || 0;
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

   const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    dispatch(resetOrderState())

    console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`);
    // tableData;
    const queryParams = {
      // type: '',
      // searchText: '',
      // fromDate: '',
      // toDate: '',
      // pageSize, // Use state value
      // pageNumber, // Use state value
      // companyKeyId
    };
    dispatch(fetchOrders(queryParams));
  }, [dispatch, pageSize, pageNumber]); // Include pageSize and pageNumber in the dependency array


  const navigateCallback = (orderId) => {
    navigate(`/view-order-inbox/${orderId}`); // Replace with your desired path
  };


  // Function to handle filter action
  const handleFilter = (criteria) => {
    const formattedCriteria = {
      search: criteria.search,
      fromDate: criteria.fromDate ? dayjs(criteria.fromDate).format('YYYY-MM-DD') : '',
      toDate: criteria.toDate ? dayjs(criteria.toDate).format('YYYY-MM-DD') : ''
    };
    setFilterCriteria(formattedCriteria);
    // Perform filtering logic based on criteria
    console.log('Filter criteria:', formattedCriteria);
    const queryParams = {
      type: 'incoming',
      searchText: formattedCriteria.search,
      fromDate: formattedCriteria.fromDate,
      toDate: formattedCriteria.toDate,
      pageSize,
      pageNumber,
    };
    dispatch(fetchOrders(queryParams));
  };

  // Function to handle reset action
  const handleReset = () => {
    setFilterCriteria({
      search: '',
      fromDate: '',
      toDate: ''
    });
    
    // Perform reset logic
    const queryParams = {
      type: 'incoming',
      searchText: '',
      fromDate: '',
      toDate: '',
      pageSize, // Use state value
      pageNumber, // Use state value
    };
    dispatch(fetchOrders(queryParams));
    console.log('Filter criteria reset', queryParams);
  };
const maskId = (id) => {
  if (!id || id.length < 8) return "Order*****";
  return `Order*****${id.slice(-4)}`; // Keep only the last 4 characters
  };
  const maskUserId = (id) => {
    if (!id || id.length < 8) return "User*****";
    return `User*****${id.slice(-4)}`; // Keep only the last 4 characters
  };
  const columnDef = columnDefDefaultFn(
    navigateCallback,
    isCancelModalOpen,
    maskId,
    maskUserId,t
  );

  const handleCreateOrderBtnClick = () => {
    navigate('/create-order'); // Navigate to create order page
  };
  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(0); // Reset to the first page when page size changes
  };

  // if (isFetchOrdersLoading) return <LoaderComp/>;
  if (isError) return <div>Error: {isError}</div>;

  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div>
            {/* <button className="btn btn-primary greeen-btn md_btn" onClick={handleCreateOrderBtnClick}>
              <span><i className="mdi mdi-plus-circle-outline"></i></span> Create New
            </button> */}
          </div>
          <div>

               <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              onClick={handleClick}
              // variant="contained"
              style={{ backgroundColor: '#6AA13C' }}
              className='btn btn-primary greeen-btn md_btn m-2 h-100'
              startIcon={<FileOutlineIcon />}
            >
              Export
            </Button>
            <Menu
              id="export-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>  
              <DownloadButton
              data={tableData}
              filename='Incoming Order List.xlsx'
              sheetname='Order List'
              forModule='Order' />
              </MenuItem>
            </Menu>
            
            <button className="btn btn-light grey-btn md_btn me-0" onClick={() => setIsFilterPanelOpen(prevState => !prevState)}>
            <span><i className="bi bi-funnel"><FilterAltOutlinedIcon /></i></span>  {t('orderOutboxcomponents.filters')}
      
            </button>
            {/* <FilterPanel onFilter={handleFilter} onReset={handleReset} /> */}
            {/* <button className="btn btn-light grey-btn md_btn me-0" onClick={() => setIsFilterPanelOpen(prevState => !prevState)}>
              <span><i className="bi bi-funnel"></i></span> {t('orderOutboxcomponents.filters')}
            </button> */}
            {/* <button className="btn btn-primary greeen-btn md_btn">
              <span><i className="mdi mdi-file-document"></i></span>{t('btnGrpText.downloadOrders')}
            </button> */}

          </div>
        </div>
      </div>
      {isFilterPanelOpen && <FilterPanel className='mb-3' onFilter={handleFilter} onReset={handleReset} />}
      {/* {isFetchOrdersLoading ? <LoaderComp /> : */}
      <MainTable
        columns={columnDef}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords} // Pass the totalRecords to MainTable
        // className="custom-table-class"
        recordCountText="total records"
      />
      {/* } */}
    </>
  )
}

export default OrdersInboxComponent;
